import classNames from 'classnames';
import { useRef, useState } from 'react';
import { FormattedMessage } from 'react-intl';

import { AuthResponse } from '../../hooks/useAuth';

import { usePopupsContext } from '../../contexts/PopupsContext';
import IdentifyForm from '../forms/IdentifyForm';
import ModalDescription from '../typography/ModalDescription';
import ModalTitle from '../typography/ModalTitle';
import Dialog from './Dialog';
import Modal from './Modal';

import styles from '../../styles/popups/identify-modal.module.css';

interface IdentifyModalProps {
    title?: string | null;
    description?: string | null;
    brand?: string | null;
    source?: string | null;
    withVerification?: boolean;
    className?: string | null;
    onClosed?: (() => void) | null;
}

function IdentifyModal({
    title = null,
    description = null,
    brand = null,
    source = null,
    withVerification = false,
    className = null,
    onClosed = null,
}: IdentifyModalProps) {
    const [opened, setOpened] = useState(true);
    const { addMessage } = usePopupsContext();
    const formRef = useRef(null);

    const onIdentify = ({ user = null, isNew = false }: AuthResponse) => {
        setOpened(false);
        addMessage('hi', {
            isNew,
            user,
        });
    };

    const onRequestClose = () => {
        setOpened(false);
    };

    return (
        <Modal
            id="identify"
            opened={opened}
            withBackdrop
            withTransition
            // withScrollLock
            requestClose={onRequestClose}
            className={classNames([styles.container, className, styles[brand]])}
            onClosed={onClosed || undefined}
        >
            <Dialog closeable onClose={onRequestClose} className={styles.dialog}>
                <div className={styles.content}>
                    <ModalTitle className={styles.title} html={title}>
                        {title === null ? (
                            <FormattedMessage
                                defaultMessage="Pour continuer..."
                                description="Identify modal title"
                            />
                        ) : null}
                    </ModalTitle>
                    <ModalDescription className={styles.description} html={description}>
                        {description === null ? (
                            <FormattedMessage
                                defaultMessage="<p>Vous devez vous identifier</p>"
                                description="Identify modal description"
                            />
                        ) : null}
                    </ModalDescription>
                </div>
                <IdentifyForm
                    ref={formRef}
                    alwaysVertical
                    withVerification={withVerification}
                    source={source || 'identify-modal'}
                    className={styles.form}
                    onComplete={onIdentify}
                />
            </Dialog>
        </Modal>
    );
}

export default IdentifyModal;
